module.exports = __webpack_public_path__ + "static/media/masked.0c304159.png";